/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  SuggestRiskPolicyRequestBody,
  SuggestRiskPolicyRequestBody$Outbound,
  SuggestRiskPolicyRequestBody$outboundSchema,
} from "../components/suggestriskpolicyrequestbody.js";

export type SuggestRiskPolicySecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type SuggestRiskPolicySecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type SuggestRiskPolicySecurity = {
  option1?: SuggestRiskPolicySecurityOption1 | undefined;
  option2?: SuggestRiskPolicySecurityOption2 | undefined;
};

export type SuggestRiskPolicyRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  suggestRiskPolicyRequestBody: SuggestRiskPolicyRequestBody;
};

/** @internal */
export type SuggestRiskPolicySecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const SuggestRiskPolicySecurityOption1$outboundSchema: z.ZodMiniType<
  SuggestRiskPolicySecurityOption1$Outbound,
  SuggestRiskPolicySecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function suggestRiskPolicySecurityOption1ToJSON(
  suggestRiskPolicySecurityOption1: SuggestRiskPolicySecurityOption1,
): string {
  return JSON.stringify(
    SuggestRiskPolicySecurityOption1$outboundSchema.parse(
      suggestRiskPolicySecurityOption1,
    ),
  );
}

/** @internal */
export type SuggestRiskPolicySecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const SuggestRiskPolicySecurityOption2$outboundSchema: z.ZodMiniType<
  SuggestRiskPolicySecurityOption2$Outbound,
  SuggestRiskPolicySecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function suggestRiskPolicySecurityOption2ToJSON(
  suggestRiskPolicySecurityOption2: SuggestRiskPolicySecurityOption2,
): string {
  return JSON.stringify(
    SuggestRiskPolicySecurityOption2$outboundSchema.parse(
      suggestRiskPolicySecurityOption2,
    ),
  );
}

/** @internal */
export type SuggestRiskPolicySecurity$Outbound = {
  Option1?: SuggestRiskPolicySecurityOption1$Outbound | undefined;
  Option2?: SuggestRiskPolicySecurityOption2$Outbound | undefined;
};

/** @internal */
export const SuggestRiskPolicySecurity$outboundSchema: z.ZodMiniType<
  SuggestRiskPolicySecurity$Outbound,
  SuggestRiskPolicySecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => SuggestRiskPolicySecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => SuggestRiskPolicySecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function suggestRiskPolicySecurityToJSON(
  suggestRiskPolicySecurity: SuggestRiskPolicySecurity,
): string {
  return JSON.stringify(
    SuggestRiskPolicySecurity$outboundSchema.parse(suggestRiskPolicySecurity),
  );
}

/** @internal */
export type SuggestRiskPolicyRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  SuggestRiskPolicyRequestBody: SuggestRiskPolicyRequestBody$Outbound;
};

/** @internal */
export const SuggestRiskPolicyRequest$outboundSchema: z.ZodMiniType<
  SuggestRiskPolicyRequest$Outbound,
  SuggestRiskPolicyRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    suggestRiskPolicyRequestBody: SuggestRiskPolicyRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      suggestRiskPolicyRequestBody: "SuggestRiskPolicyRequestBody",
    });
  }),
);

export function suggestRiskPolicyRequestToJSON(
  suggestRiskPolicyRequest: SuggestRiskPolicyRequest,
): string {
  return JSON.stringify(
    SuggestRiskPolicyRequest$outboundSchema.parse(suggestRiskPolicyRequest),
  );
}
